export interface Channels {
    from?: string
    from_page?: string
    channel_source?: string
    activity_type?: string
    inviter_id?: string
    invitation_code?: string
    anonymousLogin?: boolean
}

export interface RemoteLoginDialogOptions {
    channels?: Channels
    withoutClose?: boolean
    onClickRegister?: (method: unknown) => void
}

export interface RemoteLoginSDK {
    openLoginDialog(options: RemoteLoginDialogOptions): Promise<void>
    initSDK(): void
}

let remoteSDKLoaderPromise: Promise<RemoteLoginSDK> | null = null;

export async function initRemoteLoginSDK(): Promise<RemoteLoginSDK> {
    if (!remoteSDKLoaderPromise) {
        remoteSDKLoaderPromise = import(`${import.meta.env.VITE_CDN_BASE_URL}/login/login.sdk.es.no-cache.js`) as Promise<RemoteLoginSDK>;
    }
    return remoteSDKLoaderPromise;
}
